<template>
  <v-dialog v-model="dialogAddEdit" max-width="90%" persistent>
    <v-alert-dialog ref="alert"> </v-alert-dialog>
    <v-card>
      <v-card-title>
        "Editar Proveedor
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12" class="text-center">
            <h3>Información Básica</h3>
          </v-col>
          <v-col cols="12" md="6">
            <v-autocomplete
              :items="proveedorTipos"
              v-model="editedItem.id_proveedor_tipo"
              label="Tipo de Proveedor"
              item-value="id_proveedor_tipo"
              item-text="nombre"
              dense
              outlined
              hide-details
              disabled
              readonly
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="6">
            <v-autocomplete
              :items="personaTipos"
              v-model="editedItem.id_persona_tipo"
              label="Tipo de Persona"
              item-value="id_persona_tipo"
              item-text="nombre"
              dense
              outlined
              hide-details
            ></v-autocomplete>
          </v-col>
          <template
            v-if="
              editedItem.id_proveedor_tipo ==
              'b1921daf-3922-47ad-8a80-33a0299babe5'
            "
          >
            <v-col cols="12" md="6">
              <v-select
                label="Tipo de Proveedor Nacional*"
                dense
                outlined
                hide-details
                v-model="editedItem.id_proveedor_actividad"
                :items="proveedorActividades"
                item-text="nombre"
                item-value="id_proveedor_actividad"
              >
              </v-select>
            </v-col>
          </template>

          <v-col cols="12" md="6">
            <v-text-field
              v-model="editedItem.nombre_completo"
              label="Nombre comercial *"
              dense
              outlined
              hide-details
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model="editedItem.nombre_contacto"
              label="Nombre del Contacto *"
              dense
              outlined
              hide-details
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-autocomplete-telefono
              label="Teléfono Empresarial/Sucursal *"
              v-model="editedItem.telefono"
              url-get="/Catalogos/ListarPaises"
            />
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model="editedItem.correo_electronico"
              label="Correo Electrónico *"
              dense
              outlined
              hide-details
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="text-center">
            <h3>Datos Fiscales</h3>
          </v-col>
          <!-- Datos Fiscales Nacionales -->
          <template
            v-if="
              editedItem.id_proveedor_tipo ==
              'b1921daf-3922-47ad-8a80-33a0299babe5'
            "
          >
            <v-col cols="12" md="6">
              <v-autocomplete
                :items="regimenFiscales"
                label="Régimen Fiscal *"
                item-text="nombre"
                item-value="id_regimen_fiscal"
                dense
                outlined
                hide-details
                v-model="editedItem.id_regimen_fiscal"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Nombre/Razón Social *"
                dense
                outlined
                hide-details
                v-model="editedItem.razon_social"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <RFCField
                v-model="editedItem.rfc"
                :idProveedor="editedItem.id_proveedor"
                :idPersonaTipo="editedItem.id_persona_tipo"
              >
              </RFCField>
            </v-col>
            <v-col cols="6">
              <v-text-field
                label="Calle *"
                dense
                outlined
                hide-details
                v-model="editedItem.calle"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                label="Núm Exterior *"
                dense
                outlined
                hide-details
                v-model="editedItem.num_ext"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                label="Núm Interior"
                dense
                outlined
                hide-details
                v-model="editedItem.num_int"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                :items="estados"
                label="Estado *"
                item-value="id_estado"
                item-text="nombre"
                dense
                outlined
                hide-details
                @change="getMunicipios"
                v-model="editedItem.id_estado"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                :items="municipios"
                item-value="id_municipio"
                item-text="nombre"
                label="Municipio *"
                dense
                outlined
                hide-details
                :loading="loadingMunicipios"
                v-model="editedItem.id_municipio"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Localidad *"
                dense
                outlined
                hide-details
                v-model="editedItem.localidad"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Colonia *"
                dense
                outlined
                hide-details
                v-model="editedItem.colonia"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Código Postal *"
                dense
                outlined
                hide-details
                v-model="editedItem.codigo_postal"
              ></v-text-field>
            </v-col>
          </template>

          <!-- Datos Fiscales Internacionales -->
          <template
            v-if="
              editedItem.id_proveedor_tipo ==
              '733d857a-5692-40d7-b47c-dd0c70da0394'
            "
          >
            <v-col cols="12" md="6">
              <v-text-field
                label="Nombre/Razón Social *"
                dense
                outlined
                hide-details
                v-model="editedItem.razon_social"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Número de Identificación Fiscal *"
                dense
                outlined
                hide-details
                v-model="editedItem.numero_fiscal"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                label="Calle *"
                dense
                outlined
                hide-details
                v-model="editedItem.calle"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                label="Núm Exterior *"
                dense
                outlined
                hide-details
                v-model="editedItem.num_ext"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                label="Núm Interior"
                dense
                outlined
                hide-details
                v-model="editedItem.num_int"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Código Postal *"
                dense
                outlined
                hide-details
                v-model="editedItem.codigo_postal"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Ciudad *"
                dense
                outlined
                hide-details
                v-model="editedItem.ciudad"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Región/Estado/Provincia *"
                dense
                outlined
                hide-details
                v-model="editedItem.region"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                :items="paises"
                label="País *"
                item-value="id_pais"
                item-text="nombre"
                dense
                outlined
                hide-details
                v-model="editedItem.id_pais"
              ></v-autocomplete>
            </v-col>
          </template>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn color="green" text @click="close"> Cerrar </v-btn>
        <v-spacer> </v-spacer>
        <v-btn
          color="red"
          text
          :loading="saving"
          :disabled="saving"
          @click="save"
        >
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import axios from 'axios'
import RFCField from '../Proveedores/RFCField.vue'

export default {
  name: 'DialogoEditarProveedor',
  components:{
    RFCField
  },
  data() {
    return {
      proveedorNiveles: [],
      loadingProveedorNivel: false,

      proveedorTipos: [],
      loadingProveedorTipos: false,

      personaTipos: [],
      loadingPersonaTipos: false,

      proveedoActividades: [],
      loadingProveedorActividad: false,

      regimenFiscales: [],
      loadingRegimenFiscales: false,

      estados: [],
      loadingEstados: false,

      municipios: [],
      loadingMunicipios: false,

      paises: [],
      loadingPaises: false,

      editedItem: {
        id_proveedor: null,
        // Catálogo: Nacional / Internacional
        id_proveedor_tipo: null,
        // Catálogo: Persona Física / Persona Moral
        id_persona_tipo: null,
        // Solo Proveedor Nacional
        rfc: null,
        // Catálogo: Actividad del Proveedor (solo Nacional)
        id_proveedor_actividad: null,
        // Información Básica
        nombre_completo: '',
        nombre_contacto: '',
        correo_electronico: '',
        calle: null,
        num_ext: null,
        num_int: null,
        // Datos Fiscales Nacionales
        razon_social: null,
        id_estado: null,
        id_municipio: null,
        id_regimen_fiscal: null,
        codigo_postal: null,
        localidad: null,
        colonia: null,
        // Datos Fiscales Internacionales
        numero_fiscal: null,
        ciudad: null,
        region: null,
        id_pais: null,
        // Contacto
        telefono: null
      },
      defaultEditedItem: {
        // Catálogo: Nacional / Internacional
        id_proveedor_tipo: null,
        // Catálogo: Persona Física / Persona Moral
        id_persona_tipo: null,
        // Solo Proveedor Nacional
        rfc: null,
        // Catálogo: Actividad del Proveedor (solo Nacional)
        id_proveedor_actividad: null,
        // Información Básica
        nombre_completo: '',
        nombre_contacto: '',
        correo_electronico: '',
        calle: null,
        num_ext: null,
        num_int: null,
        // Datos Fiscales Nacionales
        razon_social: null,
        id_estado: null,
        id_municipio: null,
        id_regimen_fiscal: null,
        codigo_postal: null,
        localidad: null,
        colonia: null,
        // Datos Fiscales Internacionales
        numero_fiscal: null,
        ciudad: null,
        region: null,
        id_pais: null,
        // Contacto
        telefono: null
      },
      saving: false,

      dialogAddEdit: false,
    }
  },
   mounted() {
    this.getProveedorNiveles();
    this.getProveedorTipos();
    this.getPersonaTipos();
    this.getProveedorActividades();
    this.getRegimenFiscales();
    this.getEstados();
    this.getPaises();
  },
  methods: {
    open(item) {
      this.dialogAddEdit = true;
      this.editedItem = item;
      this.getMunicipios();
    },
    close(){
      this.dialogAddEdit = false;
      this.editedItem = Object({}, this.defaultEditedItem);
    },
    getProveedorNiveles() {
      this.loadingProveedorNivel = true;
      axios
        .get("/Proveedores/ListarProveedorNiveles")
        .then((response) => {
          this.proveedorNiveles = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingProveedorNivel = false;
        });
    },
    getProveedorTipos() {
      this.loadingProveedorTipos = true;
      axios
        .get("/Proveedores/ListarProveedorTipos")
        .then((response) => {
          this.proveedorTipos = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingProveedorTipos = false;
        });
    },
    getPersonaTipos() {
      this.loadingPersonaTipos = true;
      axios
        .get("/Proveedores/ListarPersonaTipos")
        .then((response) => {
          this.personaTipos = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingPersonaTipos = false;
        });
    },
    getProveedorActividades() {
      this.loadingProveedorActividad = true;
      axios
        .get("/Proveedores/ListarProveedorActividades")
        .then((response) => {
          this.proveedorActividades = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingProveedorActividad = false;
        });
    },
    getRegimenFiscales() {
      axios
        .get("/Catalogos/ListarRegimenFiscales")
        .then((response) => {
          this.regimenFiscales = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingRegimenFiscales = false;
        });
    },
    getEstados() {
      this.loadingEstados = true;
      axios
        .get("/Catalogos/ListarEstados")
        .then((response) => {
          this.estados = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingEstados = false;
        });
    },
    getMunicipios() {
      if (this.editedItem.id_estado == null || this.editedItem.id_estado == 0)
        return;
      this.loadingMunicipios = true;

      axios
        .get(`/Catalogos/ListarMunicipios/${this.editedItem.id_estado}`)
        .then((response) => {
          this.municipios = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingMunicipios = false;
        });
    },
    getPaises() {
      this.loadingPaises = true;

      axios
        .get("/Catalogos/ListarPaises")
        .then((response) => {
          this.paises = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingPaises = false;
        });
    },
    isValid() {
      // Validaciones comunes para todos los tipos
      if (!this.editedItem.id_proveedor_tipo) {
        this.$refs.alert.setMessage(
          "",
          "El campo Tipo de Proveedor es obligatorio"
        );
        this.$refs.alert.open();
        return false;
      }

      if (!this.editedItem.id_persona_tipo) {
        this.$refs.alert.setMessage(
          "",
          "El campo Tipo de Persona es obligatorio"
        );
        this.$refs.alert.open();
        return false;
      }

      if (!this.editedItem.nombre_completo) {
        this.$refs.alert.setMessage(
          "",
          "El campo Nombre comercial es obligatorio"
        );
        this.$refs.alert.open();
        return false;
      }

      if (!this.editedItem.nombre_contacto) {
        this.$refs.alert.setMessage(
          "",
          "El campo Nombre del Contacto es obligatorio"
        );
        this.$refs.alert.open();
        return false;
      }

      if (!this.editedItem.telefono) {
        this.$refs.alert.setMessage(
          "",
          "El campo Teléfono Empresarial/Sucursal es obligatorio"
        );
        this.$refs.alert.open();
        return false;
      }

      if (!this.editedItem.correo_electronico) {
        this.$refs.alert.setMessage(
          "",
          "El campo Correo Electrónico es obligatorio"
        );
        this.$refs.alert.open();
        return false;
      }

      // Validaciones específicas para Proveedor Nacional
      if (this.editedItem.id_proveedor_tipo == "34a6560f-61c4-4bd0-a778-b7e641818fd0")
      {
        if (!this.editedItem.rfc) {
          this.$refs.alert.setMessage("", "El campo RFC es obligatorio");
          this.$refs.alert.open();
          return false;
        }

        if (this.editedItem.id_persona_tipo === 'fd457b15-bbf2-4d2f-be75-6cacd26f523a' && this.editedItem.rfc.length !== 13)
        {
          this.$refs.alert.setMessage(
            "",
            "El RFC de una Persona Física debe tener 13 caracteres"
          );
          this.$refs.alert.open();
          return false;
        }

        if (this.editedItem.id_persona_tipo === '1e8548fd-a3d7-47ae-a34d-cba0ecee405c' && this.editedItem.length !== 12)
        {
          this.$refs.alert.setMessage(
            "",
            "El RFC de una Persona Moral debe tener 12 caracteres"
          );
          this.$refs.alert.open();
          return false;
        }

        if (!this.editedItem.id_proveedor_actividad) {
          this.$refs.alert.setMessage(
            "",
            "El campo Tipo de Proveedor Nacional es obligatorio"
          );
          this.$refs.alert.open();
          return false;
        }

        if (!this.editedItem.id_regimen_fiscal) {
          this.$refs.alert.setMessage(
            "",
            "El campo Régimen Fiscal es obligatorio"
          );
          this.$refs.alert.open();
          return false;
        }

        if (!this.editedItem.id_estado) {
          this.$refs.alert.setMessage("", "El campo Estado es obligatorio");
          this.$refs.alert.open();
          return false;
        }

        if (!this.editedItem.id_municipio) {
          this.$refs.alert.setMessage("", "El campo Municipio es obligatorio");
          this.$refs.alert.open();
          return false;
        }

        if (!this.editedItem.localidad) {
          this.$refs.alert.setMessage("", "El campo Localidad es obligatorio");
          this.$refs.alert.open();
          return false;
        }

        if (!this.editedItem.colonia) {
          this.$refs.alert.setMessage("", "El campo Colonia es obligatorio");
          this.$refs.alert.open();
          return false;
        }
      }

      // Validaciones específicas para Proveedor Internacional
      if (this.editedItem.id_proveedor_tipo == "4ae22cb8-3564-41e9-a726-302cb6762e02")
      {
        if (!this.editedItem.numero_fiscal) {
          this.$refs.alert.setMessage(
            "",
            "El campo Número de Identificación Fiscal es obligatorio"
          );
          this.$refs.alert.open();
          return false;
        }

        if (!this.editedItem.ciudad) {
          this.$refs.alert.setMessage("", "El campo Ciudad es obligatorio");
          this.$refs.alert.open();
          return false;
        }

        if (!this.editedItem.region) {
          this.$refs.alert.setMessage(
            "",
            "El campo Región/Estado/Provincia es obligatorio"
          );
          this.$refs.alert.open();
          return false;
        }

        if (!this.editedItem.id_pais) {
          this.$refs.alert.setMessage("", "El campo País es obligatorio");
          this.$refs.alert.open();
          return false;
        }
      }

      if (!this.editedItem.razon_social) {
        this.$refs.alert.setMessage(
          "",
          "El campo Nombre/Razón Social es obligatorio"
        );
        this.$refs.alert.open();
        return false;
      }

      if (!this.editedItem.calle) {
        this.$refs.alert.setMessage("", "El campo Calle es obligatorio");
        this.$refs.alert.open();
        return false;
      }

      if (!this.editedItem.num_ext) {
        this.$refs.alert.setMessage("", "El campo Núm Exterior es obligatorio");
        this.$refs.alert.open();
        return false;
      }

      if (!this.editedItem.codigo_postal) {
        this.$refs.alert.setMessage(
          "",
          "El campo Código Postal es obligatorio"
        );
        this.$refs.alert.open();
        return false;
      }

      return true;
    },
    save(){
      if(!this.isValid()) return;

      this.saving = true;

      axios
        .put(`/Proveedores/EditarProveedor/${this.editedItem.id_proveedor}`, this.editedItem)
        .then(() => {
          this.$emit('change', null);
          this.close();
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.saving = false;
        })
    },
  }
}
</script>